import Vue from 'vue'
import { Locale } from 'vant'
import VueI18n from 'vue-i18n'
import axios from 'axios'


import English from './en'
import PH from './ph'
import RU from './ru'
import BY from './by'
import KAZ from './kaz'
import ALB from './st'
import SRB from './srb'
import YD from './yd'
import TE from './te'
import TM from './tm'
import TJK from './tjk'



import enUS from 'vant/lib/locale/lang/en-US'



/*初始化*/
const lang = 'tjk'
localStorage['Language'] = 'tjk'
let locale = 'tjk'
switch (lang) {
  case 'en':
    locale = 'en-US'
    Locale.use('en-US', enUS)
    break;
  case 'ph'://菲律宾
    locale = 'ph-PH'
    Locale.use('ph-PH', enUS)
    break;
  case 'ru'://俄罗斯
    locale = 'ru'
    Locale.use('ru', RU)
  break;
  case 'yd'://俄罗斯
    locale = 'yd'
    Locale.use('yd', YD)
  break;
  case 'te'://
    locale = 'te'
    Locale.use('te', TE)
  break;
  case 'tm'://
    locale = 'tm'
    Locale.use('tm', TM)
  break;
  case 'by'://白俄罗斯
    locale = 'by'
    Locale.use('by', BY)
  break; 
  case 'kaz'://哈萨克
    locale = 'kaz'
    Locale.use('kaz', KAZ)
  break;  
  case 'st'://哈萨克
    locale = 'st'
    Locale.use('st', ALB)
  break; 
  case 'srb'://哈萨克
    locale = 'srb'
    Locale.use('srb', SRB)
  break; 
  case 'tjk':
    locale = 'tjk'
    Locale.use('tjk', TJK)
  break;
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: locale,
  messages: {
    "en-US": English,
	  "ph-PH": PH,
    "ru": RU,
    "by": BY,
    "kaz": KAZ,
	  "st":ALB,
	  "srb":SRB,
	  'yd':YD,
	  'te':TE,
	  'tm':TM,
    'tjk':TJK
  }
})

/*切換*/
export function SetLanguage(lang) {
  i18n.locale = lang
  switch (lang) {
    case 'en-US':
      localStorage['Language'] = 'en'
      Locale.use('en-US', enUS)
      break;
	  case 'ph-PH':
      localStorage['Language'] = 'ph'
      Locale.use('ph-PH', enUS)
      break;
    case 'ru':
      localStorage['Language'] = 'ru'
      Locale.use('ru', RU)
      break;
	case 'st':
	  localStorage['Language'] = 'st'
	  Locale.use('st', ALB)
	  break;  
    case 'by':
      localStorage['Language'] = 'by'
      Locale.use('by', enUS)
      break;
    case 'kaz':
      localStorage['Language'] = 'kaz'
      Locale.use('kaz', KAZ)
      break;  
	case 'yd':
	  localStorage['Language'] = 'yd'
	  Locale.use('yd', enUS)
	  break;
	case 'te':
	  localStorage['Language'] = 'te'
	  Locale.use('te', enUS)
	  break;	
	case 'tm':
	  localStorage['Language'] = 'tm'
	  Locale.use('tm', enUS)
	  break;	
	case 'tjk':
	  localStorage['Language'] = 'tjk'
	  Locale.use('tjk', TJK)
	  break;
	case 'srb':
	  localStorage['Language'] = 'srb'
	  Locale.use('srb', SRB)
	  break;  
  }
}
export default i18n